/**
 * Signals around the pure reducer. `applyEvent` is the only writer; views read `phoneState`
 * and the derived signals.
 */
import { computed, signal } from '@preact/signals';
import type { RelayEvent } from '@ccphone/contracts';
import { initialPhoneState, liveCalls, reduce, type PhoneState } from './reducer.js';

export function createPhoneStore(initial: PhoneState = initialPhoneState()) {
  const state = signal<PhoneState>(initial);
  const calls = computed(() => liveCalls(state.value));
  const nodeState = computed(() => state.value.nodeState);
  const maintenance = computed(() => state.value.maintenance);
  const presence = computed(() => state.value.presence);
  const mwi = computed(() => state.value.mwi);
  const heldBridges = computed(() => state.value.heldBridges);
  const control = computed(() => state.value.control);
  const revoked = computed(() => state.value.revoked);
  const missed = computed(() => state.value.missed);
  const recent = computed(() => state.value.recent);
  return {
    state,
    calls,
    nodeState,
    maintenance,
    presence,
    mwi,
    heldBridges,
    control,
    revoked,
    missed,
    recent,
    applyEvent(ev: RelayEvent): void {
      state.value = reduce(state.value, ev);
    },
    reset(): void {
      state.value = initialPhoneState();
    },
  };
}

export type PhoneStore = ReturnType<typeof createPhoneStore>;
